<template>
    <div class="column is-full privacy is-hidden-mobile">
        <h3 class="title is-size-4 has-text-weight-normal">
            Gizliliğini Nasıl Koruyoruz?
        </h3>
        <p class="is-size-5 has-text-grey is-size-6">Bizimle paylaştığın verileri isimsiz olarak yayınlıyor ve kişisel bilgilerini kesinlikle paylaşmıyoruz. Bu veriler sadece maaşları incelemen ve iş arayanlara yardımcı olman için kullanılır.</p>
    </div>
</template>

<script>
    export default {
        name: "Privacy"
    }
</script>

<style scoped>

</style>